/**
 * rewards.js
 * JavaScript for the Rewards page template.
 * Handles: FAQ accordion
 */

(function () {
  'use strict';

  function initFaqAccordion() {
    var faqSection = document.querySelector('.reward-faq__list');
    if (!faqSection) return;

    var buttons = faqSection.querySelectorAll('.reward-faq__question');
    var answers = faqSection.querySelectorAll('.reward-faq__answer');

    // Close all items
    function closeAll() {
      buttons.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
      answers.forEach(function (ans) {
        ans.classList.remove('reward-faq__answer--open');
        ans.style.display = 'none';
      });
    }

    // Open a specific item by index
    function openItem(index) {
      buttons[index].setAttribute('aria-expanded', 'true');
      answers[index].style.display = 'block';
      answers[index].classList.add('reward-faq__answer--open');
    }

    // Bind click handlers
    buttons.forEach(function (btn, index) {
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        closeAll();
        if (!isOpen) {
          openItem(index);
        }
      });
    });

    // Open the first item by default
    if (buttons.length > 0) {
      openItem(0);
    }
  }

  // Initialise when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqAccordion);
  } else {
    initFaqAccordion();
  }

  // Re-initialise when Shopify theme editor reloads a section
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.reward-faq__list')) {
      initFaqAccordion();
    }
  });
})();
